import type { Translation } from 'vanilla-cookieconsent';
import { Router } from '@othercommerce/foundation';

export default function createCzechTranslation(router: Router): Translation {
  return {
    consentModal: {
      title: 'Cookies',
      description: 'Na našich webových stránkách používáme cookies, abychom vám poskytli co nejrelevantnější prostředí a zachovali vaše preference mezi jednotlivými návštěvami. Kliknutím na „Přijmout vše“ souhlasíte s používáním všech cookies. Můžete však navštívit <a href="javascript:void(0)" data-cc="show-preferencesModal" class="cc-link">Nastavení</a> a udělit svůj souhlas podle jednotlivých kategorií.',
      acceptAllBtn: 'Přijmout vše',
      acceptNecessaryBtn: 'Odmítnout vše',
      showPreferencesBtn: 'Spravovat preference',
    },
    preferencesModal: {
      title: 'Nastavení cookies',
      acceptAllBtn: 'Přijmout vše',
      acceptNecessaryBtn: 'Odmítnout vše',
      savePreferencesBtn: 'Uložit nastavení',
      closeIconLabel: 'Zavřít',
      sections: [
        {
          title: 'Používání cookies',
          description: 'Cookies používáme k zajištění základních funkcí webových stránek a ke zlepšení vašeho online prostředí.',
        },
        {
          title: 'Nezbytně nutné cookies',
          description: 'Tyto cookies jsou nezbytné pro správné fungování našich webových stránek. Bez těchto cookies by webové stránky nefungovaly správně.',
          linkedCategory: 'necessary',
        },
        {
          title: 'Výkon a analytika',
          description: 'Tyto cookies umožňují webovým stránkám zapamatovat si volby, které jste v minulosti provedli.',
          linkedCategory: 'analytics',
        },
        {
          title: 'Reklama a cílení',
          description: 'Tyto cookies shromažďují informace o tom, jak webové stránky používáte, které stránky jste navštívili a na které odkazy jste klikli. Všechna data jsou anonymizována a nelze je použít k vaší identifikaci.',
          linkedCategory: 'targeting',
        },
        {
          title: 'Funkcionalita',
          description: 'Tyto cookies slouží k poskytování personalizovanějšího prostředí a k zapamatování voleb, které při používání našich webových stránek provádíte. Funkční cookies můžeme například používat k zapamatování vašich jazykových preferencí nebo přihlašovacích údajů.',
          linkedCategory: 'functionality',
        },
        {
          title: 'Další informace',
          description: 'V případě jakýchkoli dotazů týkajících se našich zásad používání cookies a vašich možností nás prosím <a class="cc-link" href="' + router.route('web.contact.index') + '">kontaktujte</a>.',
        },
      ],
    },
  };
}
